<template>
  <div class="modal-backdrop">
    <div class="modal-dialog modal-lg" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">{{ $t('list') }} {{ $t('clients-1').toLowerCase() }} {{ $t('segment-1').toLowerCase() }} "{{ this.name }}"</h5>
          <button type="button" class="close" @click="close" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <table class="table table-striped">
            <thead>
            <tr>
              <th scope="col">№</th>
              <th scope="col">{{ $t('FIO') }}</th>
              <th scope="col">E-mail</th>
              <th scope="col">{{ $t('phone') }}</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="(item, index) in segment" v-bind:key="item.id">
              <th scope="row">
                {{ index + 1}}
              </th>
              <td>{{ (item.middlename ? item.middlename : '') + ' ' + (item.firstname ? item.firstname : '') + ' ' + (item.lastname ? item.lastname : '') }}</td>
              <td>{{ item.email }}</td>
              <td>{{ item.phone }}</td>
            </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";

export default {
  name: 'client-in-segment-modal',
  props: ['id', 'name'],
  data: function(){
    return{
      segment: {
        sid: 0,
      },
      segmentName: null,
      errors: [],
    }
  },
  watch: {
    id: function (val) {
      this.segment = {
        sid: 0
      }
      this.segment.sid = val;
      this.getSegmentWithClient();
    },
  },
  methods: {
    close: function() {
      this.$emit('close');
    },
    getSegmentWithClient: function(){
      axios.post('getSegment', this.segment).then(response => {
        var status = response.data.status;
        if(status){
          this.segment = response.data.segment;
        }
      });
    }
  },
};
</script>

<style scoped>
.modal-backdrop {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: rgba(0, 0, 0, 0.3);
  display: flex;
  justify-content: center;
  align-items: center;
}

.modal-header,
.modal-footer {
  padding: 15px;
  display: flex;
}

.modal-header {
  position: relative;
  border-bottom: 1px solid #eeeeee;
  color: #000000;
  justify-content: space-between;
}

.modal-footer {
  border-top: 1px solid #eeeeee;
}
</style>